"use client";

import ContactForm from "@repo/next-shared/components/contact-form/contact-form";
import { useTranslations } from "next-intl";
import Link from "next/link";
import Icon from "@repo/ui/components/ui/icon/icon";
import { sendSupport } from "@/data/support";
import { useState } from "react";
import Toast from "@repo/ui/components/ui/toast";
import { useProductDetails } from "@/data/product-details";
import { useSearchParams } from "next/navigation";
import { sanifyProductTitle } from "@repo/next-shared/utils";

export default function HelpContactPage({ className }: any) {
  const t = useTranslations("Help.Contact-form");
  const params = useSearchParams();
  const { data: product } = useProductDetails(params.get("pid") || "");
  const [formSent, setFormSent] = useState<boolean>(false);
  const keys = [
    "topic-option-ipriceit",
    "topic-option-product",
    "topic-option-account",
    "topic-option-trust",
    "topic-option-order",
    "topic-option-proposal",
    "topic-option-payment",
    "topic-option-receipt",
    "topic-option-discount",
    "topic-option-shipment",
    "topic-option-tech-problems",
    "topic-option-return",
    "topic-option-other",
  ];

  const selectItems = keys.map((key: string) => ({
    value: key,
    label: t(`options.${key}`),
  }));

  const onSubmit = async (data: any) => {
    await sendSupport(data);
    setFormSent(true);
  };

  return (
    <div className={className}>
      <Toast
        label={t("message-sent")}
        icon="Check"
        visible={formSent}
        setIsVisible={setFormSent}
      />
      <Link
        className="flex items-center gap-2"
        href={
          product?.id
            ? `/product/${product?.id}/${sanifyProductTitle(product?.title)}`
            : "/help"
        }
      >
        <Icon
          className="max-md:hidden h-4 w-4 stroke-primary-black dark:stroke-primary-white rotate-180"
          icon="Arrow"
        />
        <Icon
          className="md:hidden h-3 w-3 stroke-primary-black dark:stroke-primary-white rotate-180"
          icon="ArrowCircle"
        />
        <span className="max-md:text-[10px] max-md:font-bold ">
          {product?.title ? t("back-to-product") : t("back")}
        </span>
      </Link>
      <div className="mt-8 max-md:mt-2 max-w-[820px] mx-auto flex flex-col items-center max-md:items-start gap-10 max-md:gap-1">
        <h2 className="max-md:text-3xl">{t("title")}</h2>
        <p className="max-w-[600px] text-center max-md:text-left text-xl max-md:text-base">
          {t.rich("subtitle", {
            br: () => <br />,
          })}
        </p>
        <ContactForm
          className="max-md:mt-8"
          selectItems={selectItems}
          onSubmit={onSubmit}
        />
      </div>
    </div>
  );
}
